import React, {Component} from 'react'
import {Alert, Button, Form, Modal} from "react-bootstrap";

class ProductStockAdjustModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isInvalid: false,
            invalidMsg: "",

            product: this.props.product,
        }

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {

    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if(value < 0){
            this.setState({
                isInvalid: true,
                invalidMsg: "Value must be positive",
            });
        } else {
            this.setState({isInvalid: false})
        }

        this.setState({
            product: {
                [name]: value
            }
        });
    }

    render() {
        return (
            <div>
                <Modal show={this.props.showHide} onHide={() => this.props.onHide({ msg: 'Cross Icon Clicked!' })}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Adjust Product Stock: {this.props.product.partNumber}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Only use this to fix stock discrepancies! For day-to-day stock checkout use the "checkout stock" modal instead.</p>
                        <Form>
                            <Form.Group>
                                <Form.Label> Current Stock Level: </Form.Label>
                                <Form.Control type="number" placeholder="Current Stock" name="currentStock"
                                              value={this.state.product.currentStock} onChange={this.handleInputChange}/>
                            </Form.Group>
                        </Form>
                        <Alert variant="danger" show={this.state.isInvalid}>
                            {this.state.invalidMsg}
                        </Alert>
                    </Modal.Body>



                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.props.onHide()} >Close</Button>
                        <Button variant="primary" onClick={() => this.props.onClick({ partNumber: this.props.product.partNumber, product: this.state.product})}
                                disabled={this.state.isInvalid}>Update</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    };
}

export default ProductStockAdjustModal;